export default "__VITE_ASSET__BtF83bnZ__"